import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { cn } from "../utils/utils";
import { useAuthState } from "react-firebase-hooks/auth";

import {
  LogOutIcon,
  PlusCircleIcon,
  UsersIcon,
  AlignHorizontalDistributeCenterIcon,
  CandlestickChartIcon,
  LayoutDashboardIcon,
  SettingsIcon,
  SheetIcon,
  BarChartBigIcon,
  ChevronRightCircleIcon,
  ChevronLeftCircleIcon,
  Building,
  Tv,
  Atom,
  FileSpreadsheetIcon,
  CpuIcon,
  AlbumIcon,
  ApertureIcon,
  BoxesIcon,
  ChartColumnIncreasingIcon,
  CalendarIcon,
  SparklesIcon,
  BriefcaseIcon,
  ActivityIcon,
} from "lucide-react";
import toast from "react-hot-toast";
import Greek from "../assests/greek.jpeg";
import { auth } from "../Login/firebase";
import Logo from "./logo";
import apiClient from "../utils/apiClient";

const Icons = {
  dashboard: <LayoutDashboardIcon className="mr-2 h-4 w-4" />,
  live: <AlignHorizontalDistributeCenterIcon className="mr-2 h-4 w-4" />,
  history: <SheetIcon className="mr-2 h-4 w-4" />,
  add: <PlusCircleIcon className="mr-2 h-4 w-4" />,
  chart: <BarChartBigIcon className="mr-2 h-4 w-4" />,
  settings: <SettingsIcon className="mr-2 h-4 w-4" />,
  orders: <SheetIcon className="mr-2 h-4 w-4" />,
  trade: <CandlestickChartIcon className="mr-2 h-4 w-4" />,
  strategyWise: <ApertureIcon className="mr-2 h-4 w-4" />,
  users: <UsersIcon className="mr-2 h-4 w-4" />,
  startegyTable: <Tv className="mr-2 h-4 w-4" />,
  startegy: <Building className="mr-2 h-4 w-4" />,
  greek: <img src={Greek} alt="Greek Logo" className="mr-2 h-4 w-4" />,
  atom: <Atom className="mr-2 h-4 w-4" />,
  vma: <Atom className="mr-2 h-4 w-4" />,
  file: <FileSpreadsheetIcon className="mr-2 h-4 w-4" />,
  data: <CpuIcon className="mr-2 h-4 w-4" />,
  source: <AlbumIcon className="mr-2 h-4 w-4" />,
  stocks: <ChartColumnIncreasingIcon className="mr-2 h-4 w-4" />,
  metrics: <BoxesIcon className="mr-2 h-4 w-4" />,
  cal: <CalendarIcon className="mr-2 h-4 w-4" />,
  alpha: <SparklesIcon className="mr-2 h-4 w-4" />,
  crm: <BriefcaseIcon className="mr-2 h-4 w-4" />,
  activity: <ActivityIcon className="mr-2 h-4 w-4" />,
};

const sideBarNavItems = [
  { title: "Monitoring", href: "/monitoring", path: "monitoring", icon: "activity" },
  {
    title: "Live Position View",
    href: "/live-position-view",
    path: "live-position-view",
    icon: "live",
  },
  {
    title: "Audit",
    href: "/audit",
    path: "audit",
    icon: "file",
  },
  {
    title: "Opportunity Screener",
    href: "/opportunity-screener",
    path: "opportunity-screener",
    icon: "alpha",
  },
  // {
  //   title: "Raw Orders & Positions",
  //   href: "/raw-orders-positions",
  //   path: "raw-orders-positions",
  //   icon: "history"
  // },
  {
    title: "Dashboard",
    href: "/dashboard",
    path: "dashboard",
    icon: "dashboard",
  },
  {
    title: "Live Metrics",
    href: "/live-metrics",
    path: "live-metrics",
    icon: "metrics",
  },
  {
    title: "Order Management",
    href: "/live-positions",
    path: "live-positions",
    icon: "live",
  },
  {
    title: "Source Tags",
    href: "/source-tags",
    path: "source-tags",
    icon: "source",
  },
  // {
  //   title: "Stocks Screener",
  //   href: "/stocks-screener",
  //   path: "stocks-screener",
  //   icon: "stocks",
  // },
  // {
  //   title: "History",
  //   href: "/history",
  //   path: "history",
  //   icon: "history",
  // },

  // {
  //   title: "Straddle table",
  //   href: "/straddle-table",
  //   path: "straddle-table",
  //   icon: "history",
  // },
  // {
  //   title: "Strategy Wise",
  //   href: "/strategy-wise",
  //   path: "strategy-wise",
  //   icon: "strategyWise",
  // },
  {
    title: "Portfolio Analyser",
    href: "/portfolio-analyser",
    path: "portfolio-analyser",
    icon: "chart",
  },
  // {
  //   title: "Pdf to Excel",
  //   href: "/pdf-to-excel",
  //   path: "pdf-to-excel",
  //   icon: "file",
  // },
  // {
  //   title: "SS Strategy",
  //   href: "/ss-strategy",
  //   path: "ss-strategy",
  //   icon: "startegy",
  // },
  // {
  //   title: "Strategy First Table",
  //   href: "/strategy-first-table",
  //   path: "strategy-first-table",
  //   icon: "startegyTable",
  // },
  // {
  //   title: "Strategy",
  //   href: "/strategy-list",
  //   path: "strategy-list",
  //   icon: "atom",
  // },
  {
    title: "Bot Config",
    href: "/bot-config",
    path: "bot-config",
    icon: "atom",
  },
  // {
  //   title: "Greeks",
  //   href: "/greeks",
  //   path: "greeks",
  //   icon: "greek",
  // },
  {
    title: "Alpha Screener",
    href: "/alpha-screener",
    path: "alpha-screener",
    icon: "alpha",
  },
  {
    title: "Data Visulaizer",
    href: "/data-visualizer",
    path: "data-visualizer",
    icon: "data",
  },
  {
    title: "Events Calendar",
    href: "/events-calendar",
    path: "events-calendar",
    icon: "cal",
  },
  {
    title: "TV Options Chart",
    href: "/tv-option-chart",
    path: "tv-option-chart",
    icon: "alpha"
  },
  {
    title: "Commodity Trades",
    href: "/commodity-trades",
    path: "commodity-trades",
    icon: "history"
  },
  {
    title: "Relative Strength",
    href: "/relative-strength",
    path: "relative-strength",
    icon: "stocks"
  },
  {
    title: "Market Breadth",
    href: "/market-breadth",
    path: "market-breadth",
    icon: "activity"
  },
  {
    title: "Clear Stocks",
    href: "/clear-stocks",
    path: "clear-stocks",
    icon: "startegyTable"
  },
  {
    title: "CRM",
    href: "/crm",
    path: "crm",
    icon: "crm",
  },
  {
    title: "Messages",
    href: "/messages",
    path: "messages",
    icon: "file",
  },
  {
    title: "Admin Panel",
    href: "/admin-panel",
    path: "admin-panel",
    icon: "users"
  }
];


export function DashboardNav({ isExpanded, toggleExpand }) {
  const path = window.location.pathname;
  const [user] = useAuthState(auth);
  const image = user && user.image;
  const email = user && user.email;
  const userName = user && user.displayName;

  // Seed from localStorage so nav is filtered correctly on first render (no flash)
  const [userAccess, setUserAccess] = useState(() => {
    try {
      const cached = localStorage.getItem("user_access");
      return cached ? JSON.parse(cached) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    const fetchAccess = async () => {
      if (user && user.email) {
        try {
          const response = await apiClient.get(`user-access?email=${user.email}`);
          if (response.data.status === "success") {
            setUserAccess(response.data.access);
            localStorage.setItem("user_access", JSON.stringify(response.data.access));
          }
        } catch (error) {
          console.error("Error fetching real-time access:", error);
          // Fallback to localStorage if API fails
          const cached = localStorage.getItem("user_access");
          if (cached) setUserAccess(JSON.parse(cached));
        }
      }
    };

    fetchAccess();
  }, [user]);

  const hasAccess = (item) => {
    if (!userAccess) return false; // Hide all items until access is known (prevents flash)

    // Every registered Godseye user can monitor; trading permissions stay separate.
    if (item.path === "monitoring") return true;
    
    if (item.title === "Admin Panel") {
      return userAccess.role === "admin";
    }

    const permissionMap = {
      "CRM": "is_crm_tab",
      "Live Position View": "is_live_position_view_access",
      "Audit": "is_audit_access",
      "Opportunity Screener": "is_opportunity_screener_access",
      "Dashboard": "is_dashboard_access",
      "Live Metrics": "is_live_metrics_access",
      "Order Management": "is_order_management_access",
      "Source Tags": "is_source_tags_access",
      "Portfolio Analyser": "is_portfolio_analyser_access",
      "Bot Config": "is_bot_config_access",
      "Alpha Screener": "is_alpha_screener_access",
      "Data Visulaizer": "is_data_visualizer_access",
      "Events Calendar": "is_events_calendar_access",
      "TV Options Chart": "is_tv_options_chart_access",
      "Commodity Trades": "is_commodity_trades_access",
      "Relative Strength": "is_relative_strength_access",
      "Market Breadth": "is_market_breadth_access",
      "Clear Stocks": "is_clear_stocks_access",
      "Messages": "is_crm_tab"
    };

    const permissionField = permissionMap[item.title];
    if (permissionField) {
      const val = userAccess[permissionField];
      if (val === false || val === null || val === undefined) {
        return false;
      }
    }
    return true;
  };

  if (!sideBarNavItems?.length) {
    return null;
  }

  const filteredNavItems = sideBarNavItems.filter(hasAccess);

  return (
    <div
      className={`sticky top-0 hidden md:flex h-screen bg-[#0c0e15] z-[1000] overflow-visible ${
        isExpanded ? "w-64" : "w-[58px]"
      } transition-width duration-300`}
    >
      <aside className="relative max-h-screen w-full flex-col md:flex space-y-0 border-r border-gray-800/80 bg-[#0c0e15]">
        <div className="flex items-center justify-between px-3.5 py-3 min-h-[52px] border-b border-gray-800/80 bg-[#0f1118]">
          <Logo isExpanded={isExpanded} />
        </div>

        <div className="absolute top-3.5 -right-3 z-[100]">
          {isExpanded ? (
            <ChevronLeftCircleIcon
              onClick={toggleExpand}
              className="h-6 w-6 text-gray-400 hover:text-white cursor-pointer bg-[#14161f] border border-gray-700 hover:border-blue-500 rounded-full shadow-md transition-all hover:scale-110"
            />
          ) : (
            <ChevronRightCircleIcon
              onClick={toggleExpand}
              className="h-6 w-6 text-gray-400 hover:text-white cursor-pointer bg-[#14161f] border border-gray-700 hover:border-blue-500 rounded-full shadow-md transition-all hover:scale-110"
            />
          )}
        </div>

        <nav className={`pt-2 bg-[#0c0e15] flex flex-col gap-0.5 w-full flex-1 overflow-y-auto overflow-x-hidden pb-24 scrollbar-thin scrollbar-thumb-gray-700`}>
          {filteredNavItems.map((item, index) => {
            const Icon = Icons[item.icon];
            const isActive = path.includes(item.path);
            return (
              item.href && (
                <div key={index} className="px-1">
                  <Link key={index} to={item.disabled ? "/" : item.href}>
                    <div
                      className={cn(
                        "group flex items-center px-2.5 py-2 text-sm rounded-r-md transition-all duration-150",
                        isActive
                          ? "bg-blue-600/15 text-blue-400 border-l-4 border-blue-500 font-semibold"
                          : "text-gray-400 hover:bg-[#1a1d29]/70 hover:text-gray-200 border-l-4 border-transparent",
                        item.disabled && "cursor-not-allowed opacity-60",
                        isExpanded ? "justify-start gap-1" : "justify-center"
                      )}
                    >
                      {Icon}
                      <span className="truncate">{isExpanded ? item.title : ""}</span>
                    </div>
                  </Link>
                </div>
              )
            );
          })}

          <div className="flex flex-col space-y-4 md:space-y-0 md:flex-row md:justify-between items-center md:px-3 md:py-2.5 border-t border-gray-800/80 bg-[#0c0e15] absolute bottom-0 left-0 right-0">
            {isExpanded && (
              <div className="flex items-center space-x-2.5 overflow-hidden">
                <img
                  src={
                    image
                      ? image
                      : "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg"
                  }
                  alt="user"
                  className="h-8 w-8 rounded-lg border border-gray-700 cursor-pointer hover:opacity-80 transition duration-200 shrink-0"
                />
                <div className="flex flex-col min-w-0">
                  <p className="text-xs text-white font-bold font-poppins truncate">
                    {userName || userName?.length > 0
                      ? userName
                      : email?.split("@")[0]}
                  </p>
                  <p className="text-[10px] text-emerald-400 font-mono flex items-center gap-1">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                    Online
                  </p>
                </div>
              </div>
            )}
            <button
              onClick={() => {
                import("../Dashboard/Operations/useGrafanaSession").then(({ revokeGrafanaSession }) => revokeGrafanaSession());
                auth.signOut();
                toast.success("Logout Successful !!", {
                  duration: 5000,
                });
              }}
              title="Logout"
              className="border border-gray-700/80 hover:border-red-500/50 bg-[#14161f] hover:bg-red-500/10 p-2 rounded-lg text-gray-400 hover:text-red-400 transition-colors shrink-0"
            >
              <LogOutIcon className="h-4 w-4" />
            </button>
          </div>
        </nav>
      </aside>
    </div>
  );
}
